import { render, staticRenderFns } from "./PostLogin.vue?vue&type=template&id=dac5efc4&scoped=true"
import script from "./PostLogin.vue?vue&type=script&lang=js"
export * from "./PostLogin.vue?vue&type=script&lang=js"
import style0 from "./PostLogin.vue?vue&type=style&index=0&id=dac5efc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac5efc4",
  null
  
)

export default component.exports